import {} from "../node/index.js";
import {} from "../port/index.js";
import {} from "./Net.js";
import { createPortFromPortEntry } from "./createPortFromPortEntry.js";
import { findPortRecordOrFail } from "./findPortRecordOrFail.js";
export function findOutputPorts(net, node) {
    const portRecord = findPortRecordOrFail(net, node);
    return Object.values(portRecord)
        .filter(({ sign }) => sign === 1)
        .map((portEntry) => createPortFromPortEntry(node, portEntry));
}
//# sourceMappingURL=findOutputPorts.js.map